import React from 'react';
import StarRatings from 'react-star-ratings';
import { createResourceLocatorString, findRouteByRouteName } from '../../../util/routes';
import { createSlug } from '../../../util/urlHelpers';
import css from './Hits.module.css';
import { ResponsiveImage, ReviewRating } from '../../../components';
import { useIntl } from 'react-intl';

const sourceUrl = process.env.REACT_APP_GUMLET_SOURCE_URL;

const ListingHit = props => {
  const { hit, routeConfiguration, history, queryID } = props;
  const intl=useIntl();
  const { title, description, price, publicData, objectID, image, user,averageRating } = hit || {};
  const { displayName } = user || {};

  const onOverListingLink = () => {
    // Enforce preloading of ListingPage (loadable component)
    const { component: Page } = findRouteByRouteName('ListingPage', routeConfiguration);
    // Loadable Component has a "preload" function.
    if (Page.preload) {
      Page.preload();
    }
  };

  const onClickListingLink = () => {
    history.push(
      createResourceLocatorString(
        'ListingPage',
        routeConfiguration,
        { id: objectID, slug: createSlug(title) },
        { queryID }
      )
    );
  };

  return (
    <div
      className={css.card}
      onMouseOver={onOverListingLink}
      onTouchStart={onOverListingLink}
      onClick={onClickListingLink}
    >
      <div className={css.imageContainer}>
        <ResponsiveImage
          alt={title}
          className={css.cardImage}
          src={image}
        />
      </div>
      <div className={css.cardBody}>
        <h3 className={css.cardTitle}>{displayName}</h3>
        <h3 className={css.cardDesc}>{title}</h3>
        {/* <h4 className={css.cardDesc}>{description}</h4> */}
        <div className={css.cardRating}>
          <h4 className={css.cardPrice}><b>${price?.amount ?? price}</b> per hour</h4>
          <span className={css.averageRating}>
            {averageRating > 0 ?
              <ReviewRating
                rating={hit.averageRating}
                className={css.mobileReviewRating}
                reviewStarClassName={css.reviewRatingStar}
                isSearchPage={true}
              />
              : <span className={css.noReviews}>
                  {intl.formatMessage({ id: 'ListingHit.noReviews' })}
              </span>
              }
          </span>
        </div>
      </div>
    </div>
  );
};

export default ListingHit;
